import "../../../resources/less/Family/ThemePages/ZombieHunters.less";
import BaseThematique from "./BaseThematique";

class ZombieHunters extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new ZombieHunters();
});
